import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useMemo } from 'react';
import cn from 'classnames';
import { useDevice } from '../../providers/Device';
import { useIsInBottomSheet } from '../../providers/IsInBottomSheetProvider';
import { BottomSheet } from '../BottomSheet/BottomSheet';
import { CloseButton } from '../CloseButton';
import styles from './CustomModal.module.scss';
export function CustomModal(props) {
    const { children, className, footer, header, style, minWidth, maxWidth = 1198, mobileMaxWidth = '90%', minHeight, maxHeight = '90vh', width, height, hideCloseBtn, onClose, disableContentScroll = false, fullSizeHeader = false, headerClassName, disableFooterPadding, contentUseFullWidth = false, openBottomSheetOnMobile, hideBottomSheetOnDismiss, testId, bi } = props, rest = _object_without_properties(props, [
        "children",
        "className",
        "footer",
        "header",
        "style",
        "minWidth",
        "maxWidth",
        "mobileMaxWidth",
        "minHeight",
        "maxHeight",
        "width",
        "height",
        "hideCloseBtn",
        "onClose",
        "disableContentScroll",
        "fullSizeHeader",
        "headerClassName",
        "disableFooterPadding",
        "contentUseFullWidth",
        "openBottomSheetOnMobile",
        "hideBottomSheetOnDismiss",
        "testId",
        "bi"
    ]);
    const { isMobileDevice } = useDevice();
    const isInBottomSheet = useIsInBottomSheet();
    const shouldHostInSheet = openBottomSheetOnMobile === true && isMobileDevice && !isInBottomSheet;
    const renderedStyle = useMemo(()=>_object_spread_props(_object_spread({}, style), {
            minWidth,
            maxWidth: isMobileDevice ? mobileMaxWidth : maxWidth,
            minHeight,
            maxHeight,
            height,
            width
        }), [
        style,
        minWidth,
        maxWidth,
        mobileMaxWidth,
        minHeight,
        maxHeight,
        height,
        width,
        isMobileDevice
    ]);
    const sheetBody = /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            header && /*#__PURE__*/ _jsx("div", {
                className: cn(styles.header, {
                    [styles.fullSizeHeader]: fullSizeHeader
                }, headerClassName),
                children: header
            }),
            /*#__PURE__*/ _jsx("div", {
                className: cn(styles.content, styles.sheetContent, {
                    [styles.disableOverflow]: disableContentScroll,
                    [styles.contentUseFullWidth]: contentUseFullWidth
                }),
                children: children
            }),
            footer && /*#__PURE__*/ _jsx("div", {
                className: cn(styles.footer, styles.sheetFooter, {
                    [styles.disablePadding]: disableFooterPadding
                }),
                children: footer
            })
        ]
    });
    if (shouldHostInSheet) {
        return /*#__PURE__*/ _jsx(BottomSheet, {
            open: true,
            replacesHostSurface: true,
            closeSheetOnLeave: hideBottomSheetOnDismiss,
            onClose: ()=>onClose === null || onClose === void 0 ? void 0 : onClose(),
            children: sheetBody
        });
    }
    return /*#__PURE__*/ _jsxs("div", _object_spread_props(_object_spread({}, rest), {
        style: renderedStyle,
        className: cn(styles.root, {
            [styles.withHeader]: header
        }, className),
        "data-testid": testId,
        children: [
            !hideCloseBtn && /*#__PURE__*/ _jsx(CloseButton, _object_spread({
                className: styles.closeBtn,
                skin: "transparent",
                testId: testId && "".concat(testId, "-close-btn"),
                onClick: onClose
            }, (bi === null || bi === void 0 ? void 0 : bi.closeButton) ? {
                bi: bi.closeButton
            } : {
                noBi: true
            })),
            header && /*#__PURE__*/ _jsx("div", {
                className: cn(styles.header, {
                    [styles.fullSizeHeader]: fullSizeHeader
                }, headerClassName),
                children: header
            }),
            /*#__PURE__*/ _jsx("div", {
                className: cn(styles.content, {
                    [styles.disableOverflow]: disableContentScroll,
                    [styles.contentUseFullWidth]: contentUseFullWidth
                }),
                children: children
            }),
            footer && /*#__PURE__*/ _jsx("div", {
                className: cn(styles.footer, {
                    [styles.disablePadding]: disableFooterPadding
                }),
                children: footer
            })
        ]
    }));
}
